import PropTypes from 'prop-types';
import { Style } from '@/components/style';
import Privacy from '@/components/customizeWelcome/components/privacy';
import { FormattedMessage } from 'react-intl';

const { gray2Color, primaryColor } = new Style().getUiConfig();

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    minHeight: '100vh',
    margin: 0,
    padding: 0,
  },
  main: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  card: {
    padding: '20px 40px',
    textAlign: 'center' as const,
    backgroundColor: '#f1f5f9', // Card background
    borderRadius: '12px',
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
  },
  title: {
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#333', // Darker text for title
    marginBottom: '8px',
  },
  subtitle: {
    fontSize: '14px',
    color: '#6c757d', // Subtle gray text
  },
  footer_css: {
    width: '100%',
    maxWidth: '640px', // 限制最大寬度
    margin: '0 auto', // 水平置中
    textAlign: 'center' as const,
    backgroundColor: '#ffffff', // 背景顏色
  },
};

function WelcomeServiceSuspended({ webStoreVo, title }) {
  return (
    <div style={styles.container}>
      <main style={styles.main}>
        <div
          className="d-flex align-items-center rounded"
          style={{ backgroundColor: '#F5F8F9', padding: '32px 46px' }}
        >
          <div>
            <div
              className="d-flex justify-content-center fw-bolder"
              style={{ fontSize: '20px', color: '#000', textAlign: 'center' }}
            >
              <FormattedMessage id="welcome.machine.offline" />
            </div>

            <div
              className="d-flex justify-content-center mt-1"
              style={{
                fontSize: '16px',
                color: '#8D8C8C',
                textAlign: 'center',
              }}
            >
              <FormattedMessage id="welcome.machine.offline.msg" />
            </div>
          </div>
        </div>
      </main>
      <div style={styles.footer_css}>
        <div>
          {/* Bottom section for Privacy and Store Info */}
          <Privacy webStoreVo={webStoreVo} />
        </div>
      </div>
    </div>
  );
}

WelcomeServiceSuspended.defaultProps = {
  webStoreVo: {},
  title: '',
};

WelcomeServiceSuspended.propTypes = {
  webStoreVo: PropTypes.any,
  title: PropTypes.string,
};

export default WelcomeServiceSuspended;
